<template>
  <footer class="footer">
    <div class="container">
      <span class="text-muted">&copy; 2024 Vue Footer. All rights reserved.</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>